import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-white border border-gray-200 rounded-xl p-4" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Admin", -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "All admins", -1)
const _hoisted_6 = {
  key: 0,
  disabled: "",
  value: "__school_admins_heading__"
}
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 1,
  disabled: "",
  value: "__separator__"
}
const _hoisted_9 = {
  key: 2,
  disabled: "",
  value: "__internal_admins_heading__"
}
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "mt-6 inline-flex items-center gap-2 text-md text-gray-700" }
const _hoisted_12 = ["checked"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Include all schools/groups for selected admin", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Date From", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2 mt-3" }, "Date To", -1)
const _hoisted_17 = ["value"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Action Type", -1)
const _hoisted_19 = ["value"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "All action types", -1)
const _hoisted_21 = ["value"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2 mt-3" }, "Entity Type", -1)
const _hoisted_23 = ["value"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "All entity types", -1)
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "mt-4 flex justify-end" }
const _hoisted_27 = ["disabled"]

import { computed } from "vue";
import {
  ActivityLogFilterOption,
  ActivityLogFilterState,
} from "@/interfaces/activity-log.interface";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityLogsFiltersComponent',
  props: {
    filters: {},
    adminOptions: {},
    actionTypeOptions: {},
    entityTypeOptions: {},
    loading: { type: Boolean }
  },
  emits: ["updateFilters", "applyFilters"],
  setup(__props: any, { emit }) {

const props = __props;





const schoolAdminOptions = computed(() =>
  props.adminOptions.filter((option) => option.group !== "internal-admins")
);

const internalAdminOptions = computed(() =>
  props.adminOptions.filter((option) => option.group === "internal-admins")
);

const onSingleSelectChange = (
  event: Event,
  key: "adminIds" | "actionTypes" | "entityTypes"
) => {
  const target = event.target as HTMLSelectElement;
  emit("updateFilters", { key, value: target.value ? [target.value] : [] });
};

const onInputDateChange = (event: Event, key: "startDate" | "endDate") => {
  const target = event.target as HTMLInputElement;
  emit("updateFilters", { key, value: target.value || "" });
};

const onCheckboxChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit("updateFilters", { key: "includeAllSchoolsForAdmin", value: target.checked });
};

return (_ctx: any,_cache: any) => {
  const _component_spinner_loader = _resolveComponent("spinner-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("select", {
          class: "w-full rounded-md border-gray-300 text-sm",
          value: _ctx.filters.adminIds[0] || '',
          onChange: _cache[0] || (_cache[0] = ($event: any) => (onSingleSelectChange($event, 'adminIds')))
        }, [
          _hoisted_5,
          (schoolAdminOptions.value.length)
            ? (_openBlock(), _createElementBlock("option", _hoisted_6, " School Admins "))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schoolAdminOptions.value, (adminOption) => {
            return (_openBlock(), _createElementBlock("option", {
              key: `school-${adminOption.id}`,
              value: adminOption.id
            }, _toDisplayString(adminOption.name), 9, _hoisted_7))
          }), 128)),
          (internalAdminOptions.value.length)
            ? (_openBlock(), _createElementBlock("option", _hoisted_8, " ------ "))
            : _createCommentVNode("", true),
          (internalAdminOptions.value.length)
            ? (_openBlock(), _createElementBlock("option", _hoisted_9, " Internal Admin (Tech) "))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(internalAdminOptions.value, (adminOption) => {
            return (_openBlock(), _createElementBlock("option", {
              key: `internal-${adminOption.id}`,
              value: adminOption.id
            }, _toDisplayString(adminOption.name), 9, _hoisted_10))
          }), 128))
        ], 40, _hoisted_4),
        _createElementVNode("label", _hoisted_11, [
          _createElementVNode("input", {
            type: "checkbox",
            class: "rounded border-gray-300",
            checked: _ctx.filters.includeAllSchoolsForAdmin,
            onChange: onCheckboxChange
          }, null, 40, _hoisted_12),
          _hoisted_13
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_14,
        _createElementVNode("input", {
          type: "date",
          class: "w-full rounded-md border-gray-300 text-sm",
          value: _ctx.filters.startDate,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (onInputDateChange($event, 'startDate')))
        }, null, 40, _hoisted_15),
        _hoisted_16,
        _createElementVNode("input", {
          type: "date",
          class: "w-full rounded-md border-gray-300 text-sm",
          value: _ctx.filters.endDate,
          onInput: _cache[2] || (_cache[2] = ($event: any) => (onInputDateChange($event, 'endDate')))
        }, null, 40, _hoisted_17)
      ]),
      _createElementVNode("div", null, [
        _hoisted_18,
        _createElementVNode("select", {
          class: "w-full rounded-md border-gray-300 text-sm",
          value: _ctx.filters.actionTypes[0] || '',
          onChange: _cache[3] || (_cache[3] = ($event: any) => (onSingleSelectChange($event, 'actionTypes')))
        }, [
          _hoisted_20,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionTypeOptions, (actionTypeOption) => {
            return (_openBlock(), _createElementBlock("option", {
              key: actionTypeOption,
              value: actionTypeOption
            }, _toDisplayString(actionTypeOption), 9, _hoisted_21))
          }), 128))
        ], 40, _hoisted_19),
        _hoisted_22,
        _createElementVNode("select", {
          class: "w-full rounded-md border-gray-300 text-sm",
          value: _ctx.filters.entityTypes[0] || '',
          onChange: _cache[4] || (_cache[4] = ($event: any) => (onSingleSelectChange($event, 'entityTypes')))
        }, [
          _hoisted_24,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityTypeOptions, (entityTypeOption) => {
            return (_openBlock(), _createElementBlock("option", {
              key: entityTypeOption,
              value: entityTypeOption
            }, _toDisplayString(entityTypeOption), 9, _hoisted_25))
          }), 128))
        ], 40, _hoisted_23)
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("button", {
        type: "button",
        class: "text-white bg-blue-600 hover:bg-blue-700 font-semibold rounded-lg px-4 py-2 flex items-center gap-2 disabled:opacity-60",
        disabled: _ctx.loading,
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('applyFilters')))
      }, [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_spinner_loader, {
              key: 0,
              color: 'text-white dark:text-white'
            }))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, _toDisplayString(_ctx.loading ? 'Filtering...' : 'Filter'), 1)
      ], 8, _hoisted_27)
    ])
  ]))
}
}

})